import React, { useCallback, useEffect } from "react";
import { Carousel } from 'antd';
import { StyleSheet } from "../StyleSheet";
import { Banners } from "../types/common";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import { getBannersImages } from "../methods/Methods";
import { AppDispatch } from "../stores/store";
import { setBanners } from "../stores/slices/bannersSlice";
import { useNavigate } from "react-router-dom";
import { getGeneralData } from "../stores/slices/generalDataSlice";

const Slider = () => {
    const bannerList = useSelector((state: any) => state.banners.banners);
    const { contracts } = useSelector(getGeneralData);
    const [bannersImg, setBannersImg] = React.useState<Array<Banners>>([]);
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();

    const validRoutes = [
        { name: "Menu", path: "/" },
        { name: "MyId", path: "/my-data" },
        { name: "MyServicesHome", path: "/my-services" },
        { name: "PaymentsHome", path: "/payments" },
        { name: "AccountStatements", path: "/" },
        { name: "AccountStatements", path: "/statement" },
        { name: "HistoryCalls", path: "/calls-history" },
        { name: "MessagesList", path: "/notifications" },
        { name: "MobileTelephony", path: "/mobile-telephony" },
        { name: "SettingsHome", path: "/settings" },
        { name: "SettingsBillingData", path: "/my-data/billing-data" },
        { name: "TvSupportHome", path: "/technical-support" },
        { name: "TvSupportAvailableChannels", path: "/technical-support/channel-list" },
        { name: "FrecuentlyQuestions", path: "/technical-support/frequently-question" },
        { name: "InternetSupport", path: "/technical-support/frequently-question" },
        { name: "FrecuentlyQuestionsInternet", path: "/technical-support/frequently-question" },
        { name: "PhoneSupportHome", path: "/technical-support/frequently-question" },
        { name: "FrecuentlyQuestionsFixedPhone", path: "/technical-support/frequently-question" },
        { name: "MovilSupportHome", path: "/technical-support/frequently-question" },
        { name: "FrequentlyQuestionsMobilePhone", path: "/technical-support/frequently-question" },
        { name: "ReferredHome", path: "/referral-system" },
        { name: "PromotionsHome", path: "/promotions" },
        { name: "FrecuentlyQuestionsHome", path: "/technical-support/frequently-question" },
        { name: "DiagnosticHome", path: "/technical-support/technical-diagnostics" },
    ];

    const getAllBanners = useCallback(async () => {
        await getBannersImages(contracts[0]?.sucursal + contracts[0]?.suscriptor, "GENERAL")
            .then((response) => {
                if (response.data && response.data.data) {
                    dispatch(setBanners({ banners: response.data.data }));
                    setBannersImg(response.data.data);
                }
            })
            .catch(() => { })
    }, [contracts, dispatch]);

    useEffect(() => {
        if (!bannerList && contracts[0] && !_.isEmpty(contracts[0])) {
            getAllBanners();
        } else {
            setBannersImg(bannerList);
        }
    }, [bannerList, contracts, getAllBanners]);

    return (
        <>
            {bannersImg && !_.isEmpty(bannersImg) ?
                <Carousel
                    autoplay={true}
                    style={styles.slideshowContainer}
                >
                    {
                        bannersImg.map((image, key) => (
                            image.isPath ?
                                (
                                    <div key={key}>
                                        {validRoutes.some(route => route.name === image.path) ? (
                                            <div onClick={() => {
                                                const matchedRoute = validRoutes.find(route => route.name === image.path);
                                                if (matchedRoute) {
                                                    navigate(matchedRoute.path);
                                                }
                                            }}>
                                                <img src={image.imgUrl} alt={"imagePromotion"} style={{ ...styles.image, cursor: "pointer" }} />
                                            </div>
                                        ) : (
                                            <img src={image.imgUrl} alt={"imagePromotion"} style={{ ...styles.image }} />
                                        )}

                                    </div>
                                )
                                : image.path ?
                                    <a key={key} href={image.path} target="_blank" rel="noopener noreferrer">
                                        <img src={image.imgUrl} alt={"imagePromotion"} style={{ ...styles.image, cursor: "pointer" }} />
                                    </a>
                                    :
                                    <div key={key} >
                                        <img src={image.imgUrl} alt={"imagePromotion"} style={styles.image} />
                                    </div>
                        ))
                    }
                </Carousel>
                : null
            }
        </>
    )
};

const styles = StyleSheet.create({
    slideshowContainer: {
        width: "100%",
        overflow: "hidden",
        borderRadius: 25
    },
    image: {
        width: '100%',
        color: "#fff",
        borderRadius: 25,
    },
});

export default Slider;